<template lang="pug">
  list(title="Open Invoice" :items="invoice" @reloadList="getOpenInvoice" :loading="loading")
</template>

<script>
import List from '../components/List'
import invoiceService from '../service.js'
export default {
  name: 'open-invoice',
  data() {
    return {
      invoice: [],
      loading: true,
    }
  },
  components: {
    List
  },
  activated() {
    this.getOpenInvoice()
  },
  created() {
    this.getOpenInvoice()
  },
  methods: {
    getOpenInvoice() {
      this.loading = true
      return invoiceService
      .getOpenInvoice()
      .then((response) => {
        console.log('response', response)
        this.invoice = response.data
        this.loading = false
        return response
      })
    }
  }
}
</script>

<style scoped>
</style>